<template>
	<modal ref="modal">
		<template #title>STOCK DETAILS COMMENTS CONTENT</template>
		<template #body>
			<div class="text-center mb-4 h3">
				<span class="badge bg-success">STOCK: {{form.stock}}</span>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="description">Comment</label>
				<textarea id="ckeditor_stockdetails_comment"></textarea>
			</div>

			<div v-if="stockDetails.stock_details_comments!==undefined && stockDetails.stock_details_comments.length>0" class="form-group mt-4 mb-4">
				<p class="fw-bold m-0">HISTORY</p>
				<table class="table">
					<thead>
						<tr>
							<th>Comment</th>
							<th>Date</th>
							<th class="text-end">:::</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(comment,index) in stockDetails.stock_details_comments" :class="{'bg-info-light':selected_id==comment.stock_comment_id}">
							<td><div v-html="comment.desc_short"></div></td>
							<td>{{comment.created_at}}</td>
							<td class="text-end">
								<span v-if="action=='add'">
									<button type="button" @click="editComment(index)" class="btn btn-xs btn-outline-info me-1"><i class="fa fa-pencil-alt"></i></button>
									<button type="button" @click="deleteComment(index)" class="btn btn-xs btn-outline-danger"><i class="fa fa-trash"></i></button>
								</span>
								<span v-else>
									<button type="button" class="btn btn-xs btn-outline-info disabled me-1"><i class="fa fa-pencil-alt"></i></button>
									<button type="button" class="btn btn-xs btn-outline-danger disabled"><i class="fa fa-trash"></i></button>
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Content</span>
				<span v-else>
					<div class="spinner-border spinner-border-sm text-dark" role="status" >
						<span class="sr-only mr-1">Please wait...</span>
					</div>
					<span class="mx-2">Please wait...</span>
				</span>
			</button>
			<button v-if="action=='add'"
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing || !form.isDirty"
			>
				<i class="fa fa-times me-1"></i>Close
			</button>
			<button v-else type="button" @click="cancelEditComment()" class="btn btn-alt-secondary"><i class="fa fa-times me-1"></i>Cancel</button>
		</template>
	</modal>

	<modal ref="modalDeleteComment">
		<template #title>DELETE CONFIRMATION</template>
		<template #body>
			<p>Are you sure, want to delete this Comment?</p>
		</template>
		<template #footer>
			<button type="button" @click="confirmDeleteComment()" class="btn btn-sm btn-outline-success">
				<div
					v-if="formDel.processing"
					class="spinner-border spinner-border-sm text-white me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				<i v-else class="fa fa-check me-1"></i>
				YES
			</button>
			<button type="button" @click="cancelDeleteComment()" class="btn btn-sm btn-outline-danger"><i class="fa fa-times me-1"></i>NO</button>
		</template>
	</modal>

</template>

<script>
import { watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditorInit from './../../Shared/ckeditor-init';

export default {
	props: {
		
	},
	emits: ['updateAction'],
	mounted(){
		CKEditorInit('ckeditor_stockdetails_comment');
	},
	setup(props,context) {
		const action 				= ref('add');
		const modal 				= ref(null);
		const modalDeleteComment 	= ref(null);

		const selected_id 	= ref(0);

		// const editor 		= ref(ClassicEditor);
		// const editorConfig 	= reactive({});

		const form = useForm({
			stock_comment_id 	: 0,
			stock 				: '',
			description 		: '',
		});

		const formDel = useForm({});

		const toggleModal = () => {
			action.value  			= 'add';
			modal.value.toggleModal();
		}


		const stockDetails = reactive({})


		const editComment = (_index)=>{

			action.value 			=  "update";

			form.stock_comment_id  	= stockDetails.stock_details_comments[_index].stock_comment_id;
			form.description  		= stockDetails.stock_details_comments[_index].description;

			window['ckeditor_stockdetails_comment'].setData(form.description);
		}

		const cancelEditComment = ()=>{
			form.stock_comment_id  	= 0;
			form.description  		= '';
			action.value  			= 'add';

			window['ckeditor_stockdetails_comment'].setData('');
		}

		const deleteComment = (_index)=>{
			selected_id.value = stockDetails.stock_details_comments[_index].stock_comment_id;
			modalDeleteComment.value.toggleModal();
		}

		const cancelDeleteComment = ()=>{
			selected_id.value = 0;
			modalDeleteComment.value.toggleModal();
		}

		const actionContent = ()=>{

			context.emit('updateAction', action.value);

			if(action.value=='update')
			{
				updateContent();
			}else 
			{
				saveContent();
			}
		}

		const saveContent = () => {
			form.description = window['ckeditor_stockdetails_comment'].getData();
			form.post('sam-table/stock-details-comments', {
				preserveState: true,
				preserveScroll: true,
				only:['stocks,search,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}


		const updateContent = () => {
			form.description = window['ckeditor_stockdetails_comment'].getData();
			form.put('sam-table/stock-details-comments/'+form.stock_comment_id, {
				preserveState: true,
				preserveScroll: true,
				only:['stocks,search,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}


		const confirmDeleteComment = () => {
			context.emit('updateAction', "delete");
			formDel.delete('sam-table/stock-details-comments/'+selected_id.value, {
				preserveState: true,
				preserveScroll: true,
				only:['stocks,search,api_response'],
				onSuccess: () => {
					modalDeleteComment.value.toggleModal();
					toggleModal();
				},
			})
		}


		const setStockDetailsCommentContent = (data)=>{
								
								form.reset();

								window['ckeditor_stockdetails_comment'].setData("");

								Object.assign(stockDetails,data);

								form.stock = data.stock;
								
							}


		return {
			action,
			selected_id,
			form,
			formDel,
			modal,
			modalDeleteComment,
			toggleModal,
			stockDetails,
			// editor,
			// editorConfig,
			setStockDetailsCommentContent,
			editComment,
			cancelEditComment,
			deleteComment,
			cancelDeleteComment,
			actionContent,
			saveContent,
			updateContent,
			confirmDeleteComment,
		}
	},
}
</script>
<style>
	.ck-content{
		height: 300px;
	}
</style>